export default __webpack_public_path__ + "static/media/red_bottle.dc43a283.svg";